import { inject, Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';
import { ToastOption } from '@shared/models/toast-option.model';
import { TranslateService } from '@shared/translate/translate.service';
import { addIcons } from 'ionicons';
import { alertCircleOutline, checkmarkCircleOutline, warningOutline, informationCircleOutline } from 'ionicons/icons';

@Injectable({
  providedIn: 'root',
})
export class ToastrService {
  private _controller = inject(ToastController);
  private _translate = inject(TranslateService);

  constructor() {
    addIcons({
      alertCircleOutline,
      checkmarkCircleOutline,
      warningOutline,
      informationCircleOutline,
    });
  }

  async error(message: string) {
    const header = 'Error';
    const icon = 'alert-circle-outline';
    const color = 'danger';
    await this.presentToast({ message, color, header, icon });
  }

  async success(message: string) {
    const header = 'Smart IOT';
    const icon = 'checkmark-circle-outline';
    const color = 'success';
    await this.presentToast({ message, color, header, icon });
  }

  async warning(message: string) {
    const header = 'Smart IOT';
    const icon = 'warning-outline';
    const color = 'warning';
    await this.presentToast({ message, color, header, icon });
  }

  async info(message: string) {
    const header = 'Smart IOT';
    const icon = 'information-circle-outline';
    const color = 'medium';
    await this.presentToast({ message, color, header, icon });
  }

  async exit() {
    const message = this._translate.instant('xBackExitApp');
    const header = 'Smart IOT';
    const icon = 'information-circle-outline';
    const color = 'secondary';
    const position = 'middle';

    const toast = await this._controller.create({
      header,
      icon,
      message,
      color,
      duration: 2000,
      position,
      cssClass: 'toastr-border',
    });
    await toast.present();
  }

  async presentToast({ message, color, header, icon, cssClass = ['toastr-border'] }: ToastOption): Promise<void> {
    const toast = await this._controller.create({
      header,
      icon,
      message,
      color,
      duration: 2500,
      position: 'top',
      cssClass,
    });

    await toast.present();
  }
}
